/**
 * DIEUKYDIEU.TV - CENTRAL STATE MANAGEMENT MODULE
 * Manages reactive state across views, language, theme, and UI toggles.
 */

export const state = {
    currentLang: 'vi',
    currentView: 'home-view',
    previousView: 'home-view',
    isSidebarCollapsed: false,
    isLiveChatOpen: false,
    currentShareData: {
        title: 'dieukydieu.tv',
        url: typeof window !== 'undefined' ? window.location.href : 'https://dieukydieu.tv'
    },
    currentTheme: 'dark'
};

export function getState(key) {
    return state[key];
}

export function setState(key, value) {
    state[key] = value;
    return state[key];
}
